/**
 * Semantic version helpers shared by the client gate and the server's minimum-version check.
 * Only the numeric core (`major.minor.patch`) is compared; pre-release tags and build metadata
 * (`1.2.3-beta+abc123`) are ignored, which is what a "please update" gate wants.
 */
export function parseVersion(input: string): [number, number, number] | null {
  const core = input.split("+")[0]?.split("-")[0] ?? "";
  const m = /^(\d+)\.(\d+)\.(\d+)$/.exec(core.trim());
  if (!m) return null;
  return [Number(m[1]), Number(m[2]), Number(m[3])];
}

/** Returns -1, 0 or 1. Unparseable versions compare as 0.0.0 so a broken header is "too old". */
export function compareVersions(a: string, b: string): -1 | 0 | 1 {
  const pa = parseVersion(a) ?? [0, 0, 0];
  const pb = parseVersion(b) ?? [0, 0, 0];
  for (let i = 0; i < 3; i++) {
    const x = pa[i] ?? 0;
    const y = pb[i] ?? 0;
    if (x < y) return -1;
    if (x > y) return 1;
  }
  return 0;
}

/** `x-client-build` is `<version>+<commit>`; this returns the version half. */
export function versionFromClientBuild(header: string | undefined): string {
  return (header ?? "").split("+")[0]?.trim() ?? "";
}
